import { Component, Inject, Output, EventEmitter, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './image-picker-dialog.component.html'
})
export class ImagePickerDialogComponent {

  imgUrl

  //TODO: passare in input questo attributo nel modo opportuno
  @Input() public settings: {
    cropper?: {
      square?: boolean
    }
  } = {cropper: {}};

  @Output() confirmation: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImagePickerDialogComponent>,
    public translate: TranslateService) 
  {
    this.imgUrl = data.imgUrl
  }

  confirm = (imgUrl) => {
    this.confirmation.emit(imgUrl)
    this.dialogRef.close({ out: imgUrl })
  }
}
